import { useState } from 'react';
import { MarginIndicator } from '@/features/quotes/components/margin-indicator';
import { MODELO_SOFTWARE } from '../data/tutorial-data';

export function MarginDemo() {
  const [margin, setMargin] = useState(25);

  const isBlocked = margin < MODELO_SOFTWARE.floorMargin;
  const requiresApproval = !isBlocked && margin < MODELO_SOFTWARE.targetMargin;

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Mueve el slider para ver como cambia el indicador de margen segun los umbrales del modelo:
      </p>

      {/* Slider */}
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <label className="text-sm font-medium">Margen: {margin}%</label>
          <div className="flex gap-4 text-xs text-muted-foreground">
            <span>
              Piso: <strong className="text-destructive">{MODELO_SOFTWARE.floorMargin}%</strong>
            </span>
            <span>
              Objetivo: <strong className="text-green-600">{MODELO_SOFTWARE.targetMargin}%</strong>
            </span>
          </div>
        </div>
        <input
          type="range"
          min={0}
          max={50}
          step={1}
          value={margin}
          onChange={(e) => setMargin(Number(e.target.value))}
          className="w-full h-2 bg-muted rounded-full appearance-none cursor-pointer accent-primary"
        />
        <div className="flex justify-between text-[10px] text-muted-foreground">
          <span>0%</span>
          <span className="text-destructive font-medium">|{MODELO_SOFTWARE.floorMargin}%</span>
          <span className="text-green-600 font-medium">|{MODELO_SOFTWARE.targetMargin}%</span>
          <span>50%</span>
        </div>
      </div>

      {/* Explanation */}
      <div className="grid grid-cols-3 gap-2 text-center text-xs">
        <div className="bg-red-50 dark:bg-red-950/30 rounded-lg p-2">
          <div className="w-3 h-3 bg-red-500 rounded-full mx-auto mb-1" />
          <p className="font-medium text-red-700 dark:text-red-400">
            &lt; {MODELO_SOFTWARE.floorMargin}%
          </p>
          <p className="text-muted-foreground">Bloqueado</p>
        </div>
        <div className="bg-orange-50 dark:bg-orange-950/30 rounded-lg p-2">
          <div className="w-3 h-3 bg-orange-500 rounded-full mx-auto mb-1" />
          <p className="font-medium text-orange-700 dark:text-orange-400">
            {MODELO_SOFTWARE.floorMargin}-{MODELO_SOFTWARE.targetMargin}%
          </p>
          <p className="text-muted-foreground">Requiere aprobacion</p>
        </div>
        <div className="bg-green-50 dark:bg-green-950/30 rounded-lg p-2">
          <div className="w-3 h-3 bg-green-500 rounded-full mx-auto mb-1" />
          <p className="font-medium text-green-700 dark:text-green-400">
            &ge; {MODELO_SOFTWARE.targetMargin}%
          </p>
          <p className="text-muted-foreground">Aprobacion automatica</p>
        </div>
      </div>

      {/* Indicator */}
      <MarginIndicator
        actualMarginPercentage={margin}
        targetMargin={MODELO_SOFTWARE.targetMargin}
        floorMargin={MODELO_SOFTWARE.floorMargin}
        requiresApproval={requiresApproval}
        isBlocked={isBlocked}
        blockReason={
          isBlocked
            ? `Margen ${margin}% esta por debajo del piso de ${MODELO_SOFTWARE.floorMargin}%`
            : undefined
        }
      />
    </div>
  );
}
